import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function listPayments({ startDate, endDate, perPage, page }) {
    return await Vue.axios.get(`${getApiUrl()}/payment?start_date=${startDate}&end_date=${endDate}&items_per_page=${perPage}&page=${page}`);
}
